import { gql } from "@grandvisionhq/graphql";
const singleEyePrescriptionValues = gql`
  fragment SingleEyePrescriptionValues on SingleEyePrescription {
    addition
    axisInt
    baseCurve
    cylinder
    diameter
    power
    pupillaryDistance
  }
`;
const GET_PRESCRIPTION_VALUES_FROM_DOCUMENT = gql`
  query GetPrescriptionValuesFromDocument($prescriptionDocument: PrescriptionDocumentInput!) {
    getPrescriptionValuesFromDocument(prescriptionDocument: $prescriptionDocument) {
      prescriptionValues {
        leftLens {
          ...SingleEyePrescriptionValues
        }
        rightLens {
          ...SingleEyePrescriptionValues
        }
      }
      resultCode
      resultMessage
      success
    }
  }

  ${singleEyePrescriptionValues}
`;
export {
  GET_PRESCRIPTION_VALUES_FROM_DOCUMENT
};
//# sourceMappingURL=get-prescription-values-from-document.js.map
